/* eslint-disable flowtype/require-valid-file-annotation */

import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import moment from "moment/moment";
import C from "../../Constants";
import {Typography} from "@material-ui/core";
import DaySpacer from "./DaySpacer";

const styles = theme => ({
    dateIsSelected: {
        backgroundColor: theme.palette.secondary.A100,
    },
    raster: {},
    dayRasterDense: {},
    dayRasterWide: {},
    hoursNavigationWidth: {},
    panel: {
        height: theme.spacing.unit * 5,
        width: "100%",
        display: "flex"
    },
    daysHeader: {
        flex: "1 1 auto",
        height: "100%",
        width: "100%",
    },
    daysContainer: {
        overflow: "hidden",
        flex: "1 1 auto",
        display: "flex",
        height: "100%",
    },
    textStyle: {
        transform: "translate(-50%, -50%)",
        left: "50%",
        position: "relative",
        top: "50%",
        lineHeight: "1.1em", overflow: "hidden"
    },
    daysNotContinuousSpacer: {
        backgroundColor: "#EEE", boxSizing: "border-box", height: "100%", width: "100%",
        borderRight: "1px solid #BBB", borderBottom: "1px solid #BBB",
    }
});

class DayNavigation extends React.Component {

    componentDidMount = () => {
        const {days} = this.refs;
        this.props.onRef(this);
    };

    scrollLeft = (left) => {
        this.refs.days.scrollLeft = left;
    };

    render() {
        const {classes} = this.props;
        const widthClass = this.props.dense ? classes.dayRasterDense : classes.dayRasterWide;
        let previousDate = null;
        const dayHeaders = this.props.hours.map((day, index) => {
            const date = moment(day[0], C.inputDatePatternMoment);
            const dateSelectedClass = date.isSame(this.props.hoveredDate) ? " " + classes.dateIsSelected : "";

            const renderedDay = <div key={index}
                                     className={classes.daysHeader + " " + widthClass + dateSelectedClass + " " + classes.raster}>
                <Typography className={classes.textStyle} align="center">
                    {date.format("dd DD MMMM")}
                </Typography></div>;

            const isContinuesDate = date.clone().subtract(1, 'day').isSame(previousDate) || previousDate == null;
            previousDate = date;
            if (isContinuesDate) {
                return renderedDay;
            } else {
                return [<DaySpacer classes={{raster: classes.raster}} key={"s" + day[0]}>
                    <div className={classes.daysNotContinuousSpacer} />
                </DaySpacer>, renderedDay]
            }
        });

        return <div className={classes.panel}>
            <div className={classes.hoursNavigationWidth + " " + classes.raster}/>
            <div className={classes.daysContainer} ref="days">{dayHeaders}</div>
        </div>;
    }
}

DayNavigation.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DayNavigation);